
import { StoreType } from "@/store/store";
import { createSelector } from "reselect";

const scoreUser = (state: StoreType) => state.scores

export const selectUserScore = createSelector(scoreUser, (score) => score.userScore)
export const selectUserScores = createSelector(scoreUser, (score) => score.userScores)
